import { Button } from '@mui/material';

import { useUngroupNodes } from './useUngroupNodes';

interface GroupNodeUngroupButtonProps {
  nodeId: string;
}

export function GroupNodeUngroupButton(props: GroupNodeUngroupButtonProps) {
  const { nodeId } = props;
  const { ungroupNodes } = useUngroupNodes();

  return (
    <Button
      variant="text"
      onClick={() => {
        ungroupNodes(nodeId);
      }}
    >
      Ungroup
    </Button>
  );
}
